import { createHttpHeader } from '@/utils/network/createHTTPHeaders';
import { decryptTreezorResponse } from '@/services/encryption/decryptTreezorResponse';
import { IPasswordStrategy } from '@/store/types/password-config.types';
import { getStaticDashboardConfig } from '@/hooks/useDashboardConfig';
import { fetchQuery } from '@/utils/queryClient';
import { fetchMethods } from '@/types/FetchService.types';

export class PasswordConfigServices {
  static queryKey = 'Password Config';
  static getPasswordPatternStrategy = async (): Promise<IPasswordStrategy> => {
    try {
      const config = getStaticDashboardConfig();

      const response = await fetchQuery(
        [this.queryKey, { method: fetchMethods.GET }],
        `${config.api.baseUrl}/core-connect/password/config`,
        {
          headers: createHttpHeader(),
        },
      );

      return await decryptTreezorResponse<IPasswordStrategy>(response, { shouldSkipEncryption: true, isSingle: true });
    } catch (err) {
      return Promise.reject(err);
    }
  };

  static setPasswordPatternStrategy = async (data: IPasswordStrategy): Promise<IPasswordStrategy> => {
    try {
      const config = getStaticDashboardConfig();

      const response = await fetchQuery(
        [this.queryKey, { method: fetchMethods.PUT, action: 'Pattern strategy' }],
        `${config.api.baseUrl}/core-connect/password/config`,
        {
          headers: createHttpHeader(),
          body: JSON.stringify(data),
        },
      );

      return await decryptTreezorResponse<IPasswordStrategy>(response, { shouldSkipEncryption: true, isSingle: true });
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
